export default __webpack_public_path__ + "static/blog-image-7-10dd60b6d6442c214e27373a81ad1009.png";